"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ValidationConstants = {
    REGEX_ZIPCODE: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i,
    REGEX_LICENSEPLATE: [/^[A-Z]{2}\-?[\d]{2}\-?[\d]{2}$/i, // 1   XX-99-99
    /^[\d]{2}\-?[\d]{2}\-?[A-Z]{2}$/i, // 2   99-99-XX
    /^[\d]{2}\-?[A-Z]{2}\-?[\d]{2}$/i, // 3   99-XX-99
    /^[A-Z]{2}\-?[\d]{2}\-?[A-Z]{2}$/i, // 4   XX-99-XX
    /^[A-Z]{2}\-?[A-Z]{2}\-?[\d]{2}$/i, // 5   XX-XX-99
    /^[\d]{2}\-?[A-Z]{2}\-?[A-Z]{2}$/i, // 6   99-XX-XX
    /^[\d]{2}\-?[A-Z]{3}\-?[\d]{1}$/i, // 7   99-XXX-9
    /^[\d]{1}\-?[A-Z]{3}\-?[\d]{2}$/i, // 8   9-XXX-99
    /^[A-Z]{2}\-?[\d]{3}\-?[A-Z]{1}$/i, // 9   XX-999-X
    /^[A-Z]{1}\-?[\d]{3}\-?[A-Z]{2}$/i, // 10  X-999-XX
    /^[A-Z]{3}\-?[\d]{2}\-?[A-Z]{1}$/i, // 11  XXX-99-X
    /^[A-Z]{1}\-?[\d]{2}\-?[A-Z]{3}$/i, // 12  X-99-XXX
    /^[\d]{1}\-?[A-Z]{2}\-?[\d]{3}$/i, // 13  9-XX-999
    /^[\d]{3}\-?[A-Z]{2}\-?[\d]{1}$/i // 14  999-XX-9
    ],
    REGEX_LICENSEPLATE_FORMATTER: [/^([A-Z]{2})\-?([\d]{2})\-?([\d]{2})$/i, // 1   XX-99-99
    /^([\d]{2})\-?([\d]{2})\-?([A-Z]{2})$/i, // 2   99-99-XX
    /^([\d]{2})\-?([A-Z]{2})\-?([\d]{2})$/i, // 3   99-XX-99
    /^([A-Z]{2})\-?([\d]{2})\-?([A-Z]{2})$/i, // 4   XX-99-XX
    /^([A-Z]{2})\-?([A-Z]{2})\-?([\d]{2})$/i, // 5   XX-XX-99
    /^([\d]{2})\-?([A-Z]{2})\-?([A-Z]{2})$/i, // 6   99-XX-XX
    /^([\d]{2})\-?([A-Z]{3})\-?([\d]{1})$/i, // 7   99-XXX-9
    /^([\d]{1})\-?([A-Z]{3})\-?([\d]{2})$/i, // 8   9-XXX-99
    /^([A-Z]{2})\-?([\d]{3})\-?([A-Z]{1})$/i, // 9   XX-999-X
    /^([A-Z]{1})\-?([\d]{3})\-?([A-Z]{2})$/i, // 10  X-999-XX
    /^([A-Z]{3})\-?([\d]{2})\-?([A-Z]{1})$/i, // 11  XXX-99-X
    /^([A-Z]{1})\-?([\d]{2})\-?([A-Z]{3})$/i, // 12  X-99-XXX
    /^([\d]{1})\-?([A-Z]{2})\-?([\d]{3})$/i, // 13  9-XX-999
    /^([\d]{3})\-?([A-Z]{2})\-?([\d]{1})$/i // 14  999-XX-9
    ],
    REGEX_PHONE: /^([+0]{1})([1-9]{1})([0-9]{8,13})$/i,
    REGEX_PHONE_MOBILE: /^([0]{1})([6]{1})([0-9]{8})$/i,
    REGEX_PHONE_PAREL: /^([0]{1})([1-9]{1})([0-9]{8})$/i,
    REGEX_EMAIL: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    REGEX_EMAIL_PAREL: /^[a-z0-9-_.]{2,}@[a-z0-9-_.]{2,}\.[a-z]{2,6}$/i,
    REGEX_CURRENCY: /^\d+([,.]\d{1,2})?$/,
    REGEX_BSN: /^[0-9]{9}$/,
    REGEX_URL: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
    REGEX_INITIALS: /^([a-zA-Z]|[cC][hH]|[cC][Hh][Rr]|[fF][Rr]|[Ii][jJ]|[jJ][aA][Cc]|[pP][Hh]|[tT][Hh]|[tT][Jj])((\.([a-zA-Z]|[cC][hC]|[cC][Hh][Rr]|[fF][Rr]|[Ii][jJ]|[jJ][aA][Cc]|[pP][Hh]|[tT][Hh]|[tT][Jj]))*)(\.)?$/,
    REGEX_LASTNAME: /^[^0-9]+$/i,
    REGEX_INTEGER: /^[-+]?\d+$/,
    REGEX_ALPHA: /^[a-zA-ZàáâäãåąćęèéêëìíîïłńòóôöõøùúûüÿýżźñçčšžÀÁÂÄÃÅĄĆĘÈÉÊËÌÍÎÏŁŃÒÓÔÖÕØÙÚÛÜŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/,
    REGEX_ALPHANUM: /^[a-zA-Z0-9àáâäãåąćęèéêëìíîïłńòóôöõøùúûüÿýżźñçčšžÀÁÂÄÃÅĄĆĘÈÉÊËÌÍÎÏŁŃÒÓÔÖÕØÙÚÛÜŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/,
    REGEX_ALPHANUM_PAREL: /^[a-zA-ZàáâäãåąćęèéêëìíîïłńòóôöõøùúûüÿýżźñçčšžÀÁÂÄÃÅĄĆĘÈÉÊËÌÍÎÏŁŃÒÓÔÖÕØÙÚÛÜŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/,
    REGEX_NUMERIC: /^[0-9]+$/,
    REGEX_NO_SPACES: /^\S+$/,
    REGEX_NO_PUNCTUATION: /^[^,.'-]+$/,
    REGEX_NO_DIACRITICS: /^[^àáâäãåąćęèéêëìíîïłńòóôöõøùúûüÿýżźñçčšžÀÁÂÄÃÅĄĆĘÈÉÊËÌÍÎÏŁŃÒÓÔÖÕØÙÚÛÜŸÝŻŹÑßÇŒÆČŠŽ∂ð]+$/
};

exports.default = ValidationConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/validation/validation.constants.js
// module id = 798
// module chunks = 0